import { CanApiAuthenticator } from "authenticators/canApiAuthenticator";
import IActivityStatusUpdate from "interfaces/IActivityStatusUpdate";
import IReactSelectValue from "interfaces/IReactSelectValue";

import { ConfigApp } from "../../configApp";
import BaseClient from "./baseClient";

export default class ActivityClient extends BaseClient {
  private endpoint: string = "api/activity";

  public constructor() {
    super(ConfigApp.endpoints.canApi, new CanApiAuthenticator());
  }

  public async finishActivitiesAsync(statusUpdate: IActivityStatusUpdate[]): Promise<Response> {
    return this.post(`${this.endpoint}/finish`, statusUpdate);
  }

  public async getCancellationReasonsAsync(): Promise<IReactSelectValue[]> {
    return this.get<IReactSelectValue[]>(`${this.endpoint}/cancellationreasons`);
  }

  public async assignOperatorToActivityAsync(activityIds: string[], customerId: string): Promise<Response> {
    return this.post(`${this.endpoint}/assign`, { activityIds, customerId });
  }
}
